import {Flex, ModalContext, Text, Title} from 'exsportia-components'
import {FC, useContext, useMemo} from 'react'
import {useQuery} from 'react-query'

import {MemberQueries} from '../../api/member'
import {QRCode} from '../../components/qr-code/qr-code'
import {Button} from '../../ui/components/button/button'
import {auth} from '../../utils/firebase'
import {useLocale} from '../../utils/i18n'

export const ContactQRModal: FC<{venueId?: string}> = ({venueId}) => {
  const {l} = useLocale()
  const userId = useMemo(() => auth.currentUser?.uid, [auth])
  const {closeModal} = useContext(ModalContext)
  const {data: member} = useQuery(MemberQueries.getMemberByVenueQuery({query: {venueId, userId}}))
  const qrLink = useMemo(() => `/contact/${member?.uid}`, [member])
  const qrCode = useMemo(() => {
    if (!member?.uid) {
      return null
    }
    return (
      <QRCode
        value={qrLink}
        settings={{size: 340}}
        text={l('yourId', {value: member.uid})}
        downloadable={false}
      />
    )
  }, [member, qrLink])
  return (
    <Flex
      alignItems='center'
      flexDirection='column'
      pb='16px'
      gap='24px'
    >
      {qrCode}
      <Title styleType='h3' text={l('scanToCheckIn')} />
      <Text text={l('contactQrDescription')} settings={{color: 'rgba(145, 147, 153, 1)', textAlign: 'center'}} />
      <Button type='flat' onClick={closeModal}>{l('close')}</Button>
    </Flex>
  )
}
